import { HostProps } from '@/utils/commonFunc';
import { useState } from 'react';
import { useLocalStorage } from './storage/useLocalStorage';

const useChatRoomDisplay = () => {
    const [isChatPanelEnabled, setIsChatPanelEnabled] = useLocalStorage(
        'chat_room',
        true
    ); //setting
    const [showOtherPlayerGift, setShowOtherPlayerGift] = useLocalStorage(
        'other_player_gift',
        true
    ); //setting
    const [loginReady, setLoginReady] = useState<boolean>(false);
    const [joinRoom, setJoinRoom] = useState<HostProps>();
    const [chatEnabled, setChatEnabled] = useState<boolean>();
    const [giftEnabled, setGiftEnabled] = useState<boolean>();
    return {
        isChatPanelEnabled,
        setIsChatPanelEnabled,
        showOtherPlayerGift,
        setShowOtherPlayerGift,
        loginReady,
        setLoginReady,
        joinRoom,
        setJoinRoom,
        chatEnabled,
        setChatEnabled,
        giftEnabled,
        setGiftEnabled,
    };
};

export default useChatRoomDisplay;
export type useChatRoomDisplayState = ReturnType<typeof useChatRoomDisplay>;
